import Vue from 'vue'

const api = () => Vue.prototype.$api

function path (resource) {
    return `/healthyHabits/${resource}`
}

export default {
    getTableData (limitDate, prevDates, allData, historyPatientId) {
			return api().get(path('table'), { params: { limitDate: limitDate, prevDates: prevDates, allData: allData, historyPatientId: historyPatientId } })
    },
    updateTableData (data) {
			return api().put(path('table'), data)
    },
    removeTableData (data) {
			return api().delete(path('table'), data)
    },
    getStatistics (id, historyPatientId) {
      return api().get(path('statistic'), { params: { id: id, historyPatientId: historyPatientId } })
    },
    getUserSetting () {
      return api().get(path('setting'))
    },
    updateSetting (nick, notificationsEmail, notificationsPhone, showStoredHabits, showGoalCompletedHabits, allowFreeDays, invertedCalendarDays) {
      return api().put(path('setting'), { nick: nick, notificationsEmail: notificationsEmail, notificationsPhone: notificationsPhone, showStoredHabits: showStoredHabits, showGoalCompletedHabits: showGoalCompletedHabits, allowFreeDays: allowFreeDays, invertedCalendarDays: invertedCalendarDays })
    },
    updateFormData (data) {
      return api().put(path('dataForm'), data)
    },
    createDataForm (data) {
      return api().post(path('dataForm'), data)
    }
}



// WEBPACK FOOTER //
// ./src/repositories/HealthyHabitsRepository.js